import { getApiBaseUrl } from '../config/constants';

// Get API base URL - centralized configuration
const API_BASE_URL = getApiBaseUrl();

export interface UserProfile {
  user_id: string;
  display_name: string;
  bio: string;
  location: string;
  phone: string;
  member_since: string | null;
  last_login: string | null;
  created_at: string | null;
  updated_at: string | null;
  date_display_opted_out?: boolean;
}

export interface ProfileUpdateRequest {
  display_name?: string;
  bio?: string;
  location?: string;
  phone?: string;
}

export class ProfileService {
  private static getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('auth_token');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  static async getUserProfile(): Promise<UserProfile> {
    try {
      const response = await fetch(`${API_BASE_URL}/profile`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching user profile:', error);
      throw error;
    }
  }

  static async createUserProfile(profile: ProfileUpdateRequest): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/profile`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(profile),
      });

      if (!response.ok) {
        throw new Error(`Failed to create profile: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating user profile:', error);
      throw error;
    }
  }

  static async updateUserProfile(profile: ProfileUpdateRequest): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/profile`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(profile),
      });

      if (!response.ok) {
        throw new Error(`Failed to update profile: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  }

  static async updateLastLogin(): Promise<void> {
    try {
      const response = await fetch(`${API_BASE_URL}/profile/login`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Failed to update last login: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating last login:', error);
      throw error;
    }
  }
} 